<template>
  <section class="assessmentSection">
    <ProgressBar :value="15" />
    <div class="pageContent mb-12">
      <div class="pageTitle">
        Let’s talk about
        <br />cameras and video
      </div>

      <div class="text-bold">Benefits of cameras and video</div>
      <div class="mb-4">
        Cameras allow you to peak in and see whats going on live. They also
        capture clips based on events like motion or doors opening.
      </div>

      <div class="text-bold">Cameras are not a replacement for security.</div>
      <div class="mb-4">
        While cameras are great, they should not be relied upon for intrusion
        events.
      </div>
    </div>

    <div class="equipment-section">
      <div class="pageContent">
        <div class="pageTitle">
          Yes, add cameras to my system
        </div>
        <div class="py-3 px-5 bg-blue text-white rounded mb-12 -mt-4">
          <b class="text-heavy mr-4">1 FREE device</b> <br class="mobile-only" /> <span class="text-sm">
            discount applied at checkout
          </span>
        </div>
        <EquipmentInfoWithQuantity :equipment="equipment" />
      </div>
    </div>

    <div class="continue-section">
      <continue-button text="Continue" :to="continueTo" />
      <ModuleNeedHelp />
    </div>
  </section>
</template>

<script>
import ProgressBar from "../components/ProgressBar.vue";
import EquipmentInfoWithQuantity from "../components/EquipmentInfoWithQuantity.vue";
import ModuleNeedHelp from "../components/ModuleNeedHelp.vue";
import EquipmentService from "../Services/Equipment";

let Equipment = new EquipmentService();

export default {
  components: {
    ProgressBar,
    EquipmentInfoWithQuantity,
    ModuleNeedHelp,
  },
  data: () => ({
    descriptionVisibilities: [false, false],
    equipment: [],
    continueTo: `/system`,
  }),
  async mounted() {
    let equipment = await Equipment.getByCategory("camera");
    this.equipment = equipment;

    if (
      this.$store.state.lead.protectionLevel === "total" &&
      !this.$route.query["continue-to-system"]
    ) {
      this.continueTo = "/home-automation";
    }
  },
};
</script>

<style src="./AssessmentModule.css" scoped></style>
<style src="../../sass/components/continue-section.css" scoped></style>
